module.exports = "/packs/images/svg/ireland/facilities/calendar~02a388742f28ec56c0eb0fbb630269bd.svg";